import React, { useEffect, useState } from "react";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import { satc_DefaultCharge } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { useTranslation } from "react-i18next";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { getAccountingDefaultCharge } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import AddDefaultCharge from "./AddDefaultCharge";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";

export default function DefaultCharges() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState();
  const [columns, setColumns] = useState([]);
  const { accountingDefaultCharge, getDefaultChargeAgain, pagination } =
    useSelector((state) => ({
      accountingDefaultCharge: state.saAccounts.accountingDefaultCharge,
      getDefaultChargeAgain: state.saAccounts.getDefaultChargeAgain,
      pagination: state.saAccounts.pagination,
    }));

  useEffect(() => {
    onEnter();
  }, []);

  const onEnter = async () => {
    setLoading(true);
    const _columns = [...satc_DefaultCharge];
    _columns[6].hidden = !read("FormDefaultCredit").accessUpdate;
    _columns[7].hidden = !read("FormDefaultCredit").accessDelete;
    setColumns(_columns);
    await getDefaltCharge(1, sizePerPage);
  };

  const getDefaltCharge = async (_page, _sizePerPage) => {
    setLoading(true);
    return new Promise(async (resolve) => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: _sizePerPage,
        Page: _page,
      };
      await dispatch(getAccountingDefaultCharge(params));
      setLoading(false);
      resolve(true);
    });
  };

  useEffect(() => {
    if (accountingDefaultCharge) {
      setTblData(accountingDefaultCharge);
      setSizePerPage(pagination.Limit);
      setCurrentPage(pagination.Page);
      setTotal(pagination.Total);
    }
  }, [accountingDefaultCharge]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      await getDefaltCharge(page, sizePerPage);
    }
  };

  useEffect(() => {
    if (getDefaultChargeAgain) {
      (async () => {
        await getDefaltCharge(currentPage, sizePerPage);
      })();
    }
  }, [getDefaultChargeAgain]);

  return (
    <>
      <div className="page-top-title-button my-3">
        <PageTitle title={<Translator id="defaultCharges" />} />
        <div className="top-buttons">
          <AddDefaultCharge disabled={loading} />
        </div>
      </div>
      <BackDropLoading loading={loading} />
      <MuiPaper>
        {columns && columns.length !== 0 && (
          <RemoteTable
            data={tblData}
            columns={columns}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
          />
        )}
      </MuiPaper>
    </>
  );
}
